import { postJSON } from '@/api/core/http/post'

import { SolanaRecentResponse, solanaRecentResponseSchema } from './schema'

const path = '/solana/blockhash/latest/' as const

export const getSolanaLatestBlockhash =
  async (): Promise<SolanaRecentResponse> =>
    postJSON<SolanaRecentResponse>(path, null, {}, solanaRecentResponseSchema)
